module.exports = __webpack_public_path__ + "files/7636fcc7d6938be98c93f966041fe512.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Ubuntu-regular.svg
 ** module id = 878
 ** module chunks = 0
 **/